<template>
  <div class="new_vip">
    <div class="content">
      <el-table
        v-if="payName == 'normal_allinpay'"
        :data="tableData"
        border
        style="width: 100%;"
      >
        <el-table-column prop="bizUserId" label="商户标识"></el-table-column>
        <el-table-column prop="mobile" label="手机号">
          <template slot-scope="scope">
            <div v-if="scope.row.memberType == 3">{{ scope.row.mobile }}</div>
            <div v-if="scope.row.memberType == 2">
              {{ scope.row.legalPhone }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称">
          <template slot-scope="scope">
            <div v-if="scope.row.memberType == 3">{{ scope.row.name }}</div>
            <div v-if="scope.row.memberType == 2">
              {{ scope.row.companyName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="银行">
          <template slot-scope="scope">
            <div v-if="scope.row.memberType == 3">
              {{ scope.row.cardBankName }}
            </div>
            <div v-if="scope.row.memberType == 2">
              {{ scope.row.parentBankName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="账户">
          <template slot-scope="scope">
            <div v-if="scope.row.memberType == 3">{{ scope.row.cardNo }}</div>
            <div v-if="scope.row.memberType == 2">
              {{ scope.row.accountNo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="daily_collection_ceiling"
          label="额度限制(0为不限制)"
        ></el-table-column>
        <el-table-column prop="is_search" label="是否显示订单">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_search"
              :active-value="1"
              active-text="展示"
              inactive-text="不展示"
              @change="is_search($event, scope.row)"
              :inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.create_time | dataFormat }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="Is_set_payment(scope.row)">
              设置收款限额
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="payName == 'lakala'"
        :data="tableData"
        border
        style="width: 100%;"
      >
        <el-table-column prop="mer_cup_no" label="商户号"></el-table-column>
        <el-table-column prop="acct_name" label="收款人"> </el-table-column>

        <el-table-column
          prop="income_max"
          label="额度限制(0为不限制)"
        ></el-table-column>
        <el-table-column prop="is_open" label="是否启用">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_open"
              :active-value="1"
              active-text="启用"
              inactive-text="不启用"
              @change="is_search($event, scope.row)"
              :inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.create_time | dataFormat }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="Is_set_payment(scope.row)">
              设置收款限额
            </el-button>
            <!-- <el-button type="text" @click="Is_set_payment(scope.row)">
              更改收款人姓名
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="payName == 'leshua'"
        :data="tableData"
        border
        style="width: 100%;"
      >
        <el-table-column prop="merchant_id" label="商户号"></el-table-column>
        <el-table-column prop="acct_name" label="收款人"> </el-table-column>

        <el-table-column
          prop="income_max"
          label="额度限制(0为不限制)"
        ></el-table-column>
        <el-table-column prop="is_open" label="是否启用">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_open"
              :active-value="1"
              active-text="启用"
              inactive-text="不启用"
              @change="is_search($event, scope.row)"
              :inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.create_time | dataFormat }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="Is_set_payment(scope.row)">
              设置收款限额
            </el-button>
            <!-- <el-button type="text" @click="Is_set_payment(scope.row)">
              更改收款人姓名
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div style="font-size: 20px; margin: 10px 0;">隐私设置</div>
      <el-form ref="form" label-width="auto">
        <el-form-item label="交班充值统计">
          <el-switch
            v-model="duty_charge_count"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="交班记录">
          <el-switch
            v-model="duty_logs"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="余额记录/变动记录">
          <el-switch
            v-model="balance_logs"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="收款人隐藏">
          <el-switch
            v-model="income_name"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="自定义交班时间">
          <el-switch
            v-model="duty_custom"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="客户列表统计">
          <el-switch
            v-model="userlist_count"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="客户列表查看统计(按钮)">
          <el-switch
            v-model="userlist_check"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="交班报表数据隐藏">
          <el-switch
            v-model="duty_bank_arrival"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="积分记录隐藏">
          <el-switch
            v-model="point_logs"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="当前班次隐藏">
          <el-switch
            v-model="today_duty"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="上一班次隐藏">
          <el-switch
            v-model="last_duty"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="消费订单隐藏">
          <el-switch
            v-model="order_list"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="充值订单隐藏">
          <el-switch
            v-model="recharge_list"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item label="普通订单隐藏">
          <el-switch
            v-model="normal_list"
            active-text="显示"
            inactive-text="隐藏"
          ></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="set_privacy">保 存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      width="350px"
      center
      append-to-body
      destroy-on-close
      :before-close="beforeClose"
      @close="Isshow = false"
      title="设置收款限额"
      :visible.sync="Isshow"
    >
      <el-input placeholder="请输入限制金额(0代表不限制)" v-model="money">
        <template slot="append">元</template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Isshow = false">关 闭</el-button>
        <el-button type="primary" @click="set_payment">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  tlpay_list,
  tlpay_config,
  set_is_search,
  set_sorts,
  privacy_set,
  privacy,
  get_biz_user_id,
  get_pay_name,
  get_lakala_list,
  get_leshua_list,
  get_lakala_edit,
  get_leshua_edit,
} from "@/api/set";
export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  data() {
    return {
      tableData: [],
      duty_charge_count: false,
      income_name: true,
      duty_logs: true,
      balance_logs: true,
      duty_custom: true,
      userlist_count: true,
      userlist_check: true,
      duty_bank_arrival: true,
      point_logs: true,
      today_duty: true,
      last_duty: true,
      order_list: true,
      recharge_list: true,
      normal_list: true,
      row: {},
      Isshow: false,
      money: "",
      biz_user_ids: [],
      payName: "",
    };
  },
  mounted() {
    this.getPayName();
    this.getSetyinsi();
  },
  methods: {
    async getLakala() {
      const res = await get_lakala_list({ app_id: this.app_id });
      if (res.code == 200) {
        this.tableData = res.data;
      }
    },
    async getLeshua() {
      const res = await get_leshua_list({ app_id: this.app_id });
      if (res.code == 200) {
        this.tableData = res.data;
      }
    },
    async getPayName() {
      const res = await get_pay_name({ app_id: this.app_id });
      if (res.code == 200) {
        this.payName = res.data.type_name;
        if (this.payName == "normal_allinpay") {
          this.getlist();
        }
        if (this.payName == "lakala") {
          this.getLakala();
        }
        if (this.payName == "leshua") {
          this.getLeshua();
        }
      }
    },
    async editLakala(row, datas) {
      const res = await get_lakala_edit({
        app_id: this.app_id,
        id: row.id,
        is_open: datas.is_open ? datas.is_open : row.is_open,
        mer_cup_no: row.mer_cup_no,
        acct_name: row.acct_name,
        income_max: datas.income_max ? datas.income_max : row.income_max,
      });
      if (res.code == 200) {
        this.$message.success("设置成功！");
        this.money = "";
        this.row = {};
        this.Isshow = false;
      } else {
        this.$message.error(res.msg);
      }
      this.getLakala();
    },
    async editLeshua(row, datas) {
      const res = await get_leshua_edit({
        app_id: this.app_id,
        id: row.id,
        is_open: datas.is_open ? datas.is_open : row.is_open,
        merchant_id: row.merchant_id,
        acct_name: row.acct_name,
        income_max: datas.income_max ? datas.income_max : row.income_max,
      });
      if (res.code == 200) {
        this.$message.success("设置成功！");
        this.money = "";
        this.row = {};
        this.Isshow = false;
      } else {
        this.$message.error(res.msg);
      }
      this.getLeshua();
    },
    async getSetyinsi() {
      const res = await privacy({ app_id: this.app_id });
      if (res.code == 200) {
        console.log(res);
        if (res.data) {
          this.duty_charge_count = Boolean(res.data.duty_charge_count);
          this.balance_logs = Boolean(res.data.balance_logs);
          this.duty_custom = Boolean(res.data.duty_custom);
          this.duty_logs = Boolean(res.data.duty_logs);
          this.userlist_count = Boolean(res.data.userlist_count);
          this.income_name = Boolean(res.data.income_name);
          this.userlist_check = Boolean(res.data.userlist_check);
          this.duty_bank_arrival = Boolean(res.data.duty_bank_arrival);
          this.point_logs = Boolean(res.data.point_logs);
          this.today_duty = Boolean(res.data.today_duty);
          this.last_duty = Boolean(res.data.last_duty);
          this.order_list = Boolean(res.data.order_list);
          this.recharge_list = Boolean(res.data.recharge_list);
          this.normal_list = Boolean(res.data.normal_list);
        }
      }
    },
    async set_privacy() {
      const res = await privacy_set({
        duty_charge_count: Number(this.duty_charge_count),
        duty_logs: Number(this.duty_logs),
        balance_logs: Number(this.balance_logs),
        income_name: Number(this.income_name),
        duty_custom: Number(this.duty_custom),
        userlist_count: Number(this.userlist_count),
        userlist_check: Number(this.userlist_check),
        duty_bank_arrival: Number(this.duty_bank_arrival),
        point_logs: Number(this.point_logs),
        today_duty: Number(this.today_duty),
        last_duty: Number(this.last_duty),
        order_list: Number(this.order_list),
        recharge_list: Number(this.recharge_list),
        normal_list: Number(this.normal_list),
        app_id: this.app_id,
      });
      if (res.code == 200) {
        console.log(res);
        this.$message.success("设置成功");
      }
    },
    async is_search(e, it) {
      console.log(e);
      if (this.payName == "normal_allinpay") {
        const res = await set_is_search({ id: it.id, is_search: e });
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getlist();
        } else {
          this.$message.error(res.msg);
        }
      }
      if (this.payName == "lakala") {
        this.editLakala(it, { is_open: e });
      }
      if (this.payName == "leshua") {
        this.editLeshua(it, { is_open: e, income_max: "0" });
      }
    },
    beforeClose(done) {
      this.money = "";
      this.row = {};
      done();
    },
    async getlist() {
      const res = await tlpay_list({ app_id: this.app_id });
      if (res.code == 200) {
        let tableData = res.data.allinpay_member_list;
        let biz_user_ids = [];
        const list = await get_biz_user_id({ app_id: this.app_id });
        if (list.code == 200) {
          let data = list.data;
          if (data.is_multi_member == 1) {
            let arr = data.biz_user_id.split(",");
            arr.map((item) => {
              if (tableData.find((x) => x.bizUserId == item)) {
                biz_user_ids.push(tableData.find((x) => x.bizUserId == item));
              }
            });
          } else if (data.is_multi_member == 0) {
            if (tableData.find((x) => x.bizUserId == data.biz_user_id)) {
              biz_user_ids.push(
                tableData.find((x) => x.bizUserId == data.biz_user_id)
              );
            }
          } else {
            this.tableData = biz_user_ids;
          }
          this.tableData = biz_user_ids;
        }
      }
    },
    Is_set_payment(row) {
      this.row = row;
      this.money =
        this.payName == "lakala"
          ? row.income_max
          : this.payName == "normal_allinpay"
          ? row.daily_collection_ceiling
          : this.payName == "leshua"
          ? row.income_max
          : "";
      this.Isshow = true;
    },
    async set_payment() {
      if (this.payName == "lakala") {
        this.editLakala(this.row, { income_max: this.money });
      }
      if (this.payName == "leshua") {
        this.editLeshua(this.row, { income_max: this.money });
      }
      if (this.payName == "normal_allinpay") {
        const res = await tlpay_config({
          daily_collection_ceiling: this.money,
          id: this.row.id,
        });
        if (res.code == 200) {
          this.$message.success("设置成功");
          this.money = "";
          this.row = {};
          this.Isshow = false;
          this.getlist();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.new_vip {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  .content {
    background: #fff;
    overflow: auto;
    height: 100%;
    padding: 20px;
  }
}
</style>
